import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import { ReactComponent as Logo } from '../censuszen-logo.svg';
import '../styles/Auth.css';

const FACILITY_TYPES = [
    { value: 'IPR', label: 'Inpatient Rehabilitation (IPR)' },
    { value: 'LTACH', label: 'Long-Term Acute Care (LTACH)' },
    { value: 'Home Health', label: 'Home Health' },
    { value: 'Hospice', label: 'Hospice' },
    { value: 'Other', label: 'Other' },
];

export const RequestAccess = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [organization, setOrganization] = useState('');
    const [facilityType, setFacilityType] = useState('');
    const [facilityTypeOther, setFacilityTypeOther] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [alreadyRegistered, setAlreadyRegistered] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const payload = {
                email: email.trim(),
                name: name.trim(),
                organization: organization.trim(),
                facility_type: facilityType,
            };
            if (facilityType === 'Other' && facilityTypeOther.trim()) {
                payload.facility_type_other = facilityTypeOther.trim();
            }

            const resp = await api.post('/user/request-access', payload);
            setAlreadyRegistered(resp.data.already_registered);
            setSubmitted(true);
        } catch (err) {
            const msg = err.response?.data?.detail || err.message || 'Something went wrong. Please try again.';
            setError(typeof msg === 'string' ? msg : 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className="auth-page">
                <div className="auth-container">
                    <Link to="/" className="auth-logo-link">
                        <Logo className="auth-logo" aria-label="CensusZen" />
                    </Link>
                    <div className="auth-form">
                        <h2 className="auth-title">
                            {alreadyRegistered ? "You're already on the list!" : "You're on the list!"}
                        </h2>
                        <p className="auth-subtitle">
                            {alreadyRegistered
                                ? "We already have your information. We'll reach out when your access is ready."
                                : "Thanks for your interest in CensusZen. We'll reach out when your access is ready."}
                        </p>
                        <div className="auth-links">
                            <Link to="/">Back to home</Link>
                            <Link to="/login">Sign in</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="auth-container auth-container--wide">
                <Link to="/" className="auth-logo-link">
                    <Logo className="auth-logo" aria-label="CensusZen" />
                </Link>
                <form onSubmit={handleSubmit} className="auth-form">
                    <h2 className="auth-title">Request early access</h2>
                    <p className="auth-subtitle">
                        CensusZen is currently in private beta. Leave your details and we'll be in touch.
                    </p>
                    {error && <div className="auth-error">{error}</div>}

                    <div className="auth-field">
                        <label htmlFor="raName">Full Name</label>
                        <input
                            id="raName"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            autoComplete="name"
                            placeholder="Jane Smith"
                        />
                    </div>

                    <div className="auth-field">
                        <label htmlFor="raEmail">Work Email</label>
                        <input
                            id="raEmail"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="email"
                            placeholder="you@yourfacility.com"
                        />
                    </div>

                    <div className="auth-field">
                        <label htmlFor="raOrganization">Facility / Organization</label>
                        <input
                            id="raOrganization"
                            type="text"
                            value={organization}
                            onChange={(e) => setOrganization(e.target.value)}
                            required
                            placeholder="ACME Rehabilitation Center"
                        />
                    </div>

                    <div className="auth-field">
                        <label htmlFor="raFacilityType">Facility Type</label>
                        <select
                            id="raFacilityType"
                            value={facilityType}
                            onChange={(e) => setFacilityType(e.target.value)}
                            required
                        >
                            <option value="" disabled>Select your facility type</option>
                            {FACILITY_TYPES.map((ft) => (
                                <option key={ft.value} value={ft.value}>
                                    {ft.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {facilityType === 'Other' && (
                        <div className="auth-field">
                            <label htmlFor="raFacilityTypeOther">Please specify</label>
                            <input
                                id="raFacilityTypeOther"
                                type="text"
                                value={facilityTypeOther}
                                onChange={(e) => setFacilityTypeOther(e.target.value)}
                                placeholder="e.g. Skilled Nursing Facility"
                            />
                        </div>
                    )}

                    <button
                        type="submit"
                        className="auth-submit"
                        disabled={loading || !facilityType}
                    >
                        {loading ? 'Submitting...' : 'Request Access'}
                    </button>

                    <div className="auth-links">
                        <Link to="/login">Already have an account? Sign in</Link>
                        <Link to="/register">Have an invite code? Register</Link>
                    </div>
                </form>
            </div>
        </div>
    );
};
